import React from 'react';
import {useFormState} from 'react-use-form-state';

import {EqualColumns, Input, Label, Select} from 'ui-kit';
import {MONTHS, daysInMonth} from 'utilities';

const thisYear = new Date().getFullYear();
const years = Array.from(Array(115), (_, index) => thisYear - index);

export function MemberFields({member, onChange, errors = {}}) {
  const [state, {text, select}] = useFormState(member, {
    onChange: (_, __, nextState) => {
      onChange(nextState);
    },
  });

  return (
    <>
      <EqualColumns>
        <Input label="First name*" {...text('firstName')} noPadding />
        <Input label="Last name*" {...text('lastName')} noPadding />
        <Input label="Email" {...text('email')} noPadding />
        <Input label="Phone number" {...text('phone')} noPadding />
      </EqualColumns>

      <Label>Date of birth*</Label>

      <EqualColumns columns={3}>
        <Select {...select('dobMonth')}>
          {MONTHS.map((month, index) => (
            <option value={index} key={month}>
              {month}
            </option>
          ))}
        </Select>

        <Select {...select('dobDay')}>
          {Array(daysInMonth(state.values.dobYear, state.values.dobMonth))
            .fill(null)
            .map((_, index) => (
              <option value={index + 1} key={index}>
                {index + 1}
              </option>
            ))}
        </Select>

        <Select {...select('dobYear')}>
          {years.map(year => (
            <option value={year} key={year}>
              {year}
            </option>
          ))}
        </Select>
      </EqualColumns>
    </>
  );
}
